import { Paper, Skeleton } from "@mui/material";
import React from "react";

const TableGridSkeleton = ({ showProfileSkeleton = false }) => {
  const skeletonItems = Array.from({ length: 6 }, (_, index) => (
    <div key={index} style={{ flex: "1", marginRight: "10px" }}>
      <Skeleton animation="wave" variant="text" height="25px" />
      <Skeleton animation="wave" variant="text" height="15px" width="150px" />
    </div>
  ));

  return (
    <>
      {!showProfileSkeleton ? (
        <Paper
          sx={{
            padding: "0px 16px 16px 16px",
            boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.06)",
          }}
          elevation={4}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              paddingLeft: "1.6rem",
              paddingTop: "2rem",
            }}
          >
            {skeletonItems}
          </div>
        </Paper>
      ) : (
        <Paper
          sx={{
            padding: "0px 16px 16px 16px",
            boxShadow: "0px 5px 25px rgba(0, 0, 0, 0.06)",
          }}
          elevation={4}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              paddingLeft: "1.6rem",
              paddingTop: "2rem",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton
              animation="wave"
              variant="text"
              height="20px"
              width="150px"
            />
          </div>
        </Paper>
      )}
    </>
  );
};

export default TableGridSkeleton;
